export default "__VITE_ASSET__C39vFVrL__"